<app-main-layout-spacer>
  <app-common-id-sign-in-header data-no-print></app-common-id-sign-in-header>
  <router-outlet></router-outlet>
  <app-common-id-footer data-no-print></app-common-id-footer>
  <app-common-id-bottom-toast-banner *ngIf="isBottomToastBannerVisible"></app-common-id-bottom-toast-banner>
</app-main-layout-spacer>

<app-bottom-tab-ui data-no-print></app-bottom-tab-ui>
